"use client";

import { useWeb3 } from "logic/components";
import { type Address, erc20Abi, zeroAddress } from "viem";

import { useContractView } from "../contracts";

interface UseERC20AllowanceParams {
  erc20Address: Address;
  spenderAddress: Address | undefined;
  watch?: boolean;
  enabled?: boolean;
  chainId?: number;
}

export function useERC20Allowance(params: UseERC20AllowanceParams) {
  const { erc20Address, spenderAddress, watch, enabled = true, chainId } = params;

  const { address } = useWeb3();

  return useContractView({
    abi: erc20Abi,
    address: erc20Address,
    functionName: "allowance",
    args: address && spenderAddress ? [address, spenderAddress] : undefined,
    watch,
    chainId,
    query: {
      enabled: Boolean(address && address != zeroAddress && spenderAddress && spenderAddress != zeroAddress && enabled),
    },
  });
}
